<template>
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.1626 10.0745L7.56641 10.8831V12.2322L3.68164 10.6501V9.4812L7.56641
        7.89917V9.2439L5.1626 10.0745ZM8.99023 13.3H7.93994L10.124 6.35229H11.1787L8.99023
        13.3ZM14.1099 10.0613L11.7192 9.24829V7.90356L15.582 9.4856V10.6545L11.7192
        12.2366V10.8918L14.1099 10.0613Z"
      fill="#A2B1C6"
    />
    <path
      d="M2.17041 0.0637207H16.2185V1.56372H2.17041V9.30354H0.67041V1.56372C0.67041 0.73872
      1.34541 0.0637207 2.17041 0.0637207Z"
      fill="#A2B1C6"
    />
    <path
      d="M17.1704 0.0637207H15.3052V1.56372H17.1704V9.84163H18.6704V1.56372C18.6704 0.73872
      17.9954 0.0637207 17.1704 0.0637207Z"
      fill="#A2B1C6"
    />
    <path
      d="M2.17041 17.1098H15.8754V15.6098H2.17041V8.78486H0.67041V15.6098C0.67041 16.4348
      1.34541 17.1098 2.17041 17.1098Z"
      fill="#A2B1C6"
    />
    <path
      d="M17.1704 17.1098H15.3052V15.6098H17.1704V8.55939H18.6704V15.6098C18.6704 16.4348
      17.9954 17.1098 17.1704 17.1098Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1197 4.13787H1.76172V3.03787H18.1197V4.13787Z"
      fill="#A2B1C6"
    />
  </svg>
</template>

<script>
export default {
  name: 'HtmlIcon'
}
</script>
